var _text, _text2, _text3, _text4, _text5, _text6, _line, _line2, _line3, _line4, _line5, _path, _path2, _g, _g2, _g3, _path3, _path4, _path5, _g4, _g5, _g6, _g7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 347,
    viewBox: "0 0 218 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 30,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Networth"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 90,
    fill: "#0B2653",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", null, "Goals & Expenses"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 145,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Post Retirement Income"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 203,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Risk Assesment"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 257,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Asset Allocation"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 315,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Portfolio Construction"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 46,
    x2: 33,
    y2: 68,
    stroke: "#27AE60",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 103,
    x2: 33,
    y2: 127,
    stroke: "#B9C2D0",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 159,
    x2: 33,
    y2: 183,
    stroke: "#B9C2D0",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 215,
    x2: 33,
    y2: 239,
    stroke: "#B9C2D0",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 271,
    x2: 33,
    y2: 295,
    stroke: "#B9C2D0",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 66C34.7578 66 37.4885 66.5432 40.0364 67.5985C42.5842 68.6539 44.8992 70.2007 46.8492 72.1508C48.7993 74.1008 50.3461 76.4158 51.4015 78.9636C52.4568 81.5115 53 84.2422 53 87L50.0802 87C50.0802 84.6257 49.6126 82.2746 48.704 80.081C47.7953 77.8874 46.4636 75.8942 44.7847 74.2153C43.1058 72.5364 41.1126 71.2047 38.919 70.296C36.7254 69.3874 34.3743 68.9198 32 68.9198L32 66Z",
    fill: "#51668A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 7C43.598 7 53 16.402 53 28C53 39.598 43.598 49 32 49C20.402 49 11 39.598 11 28C11 16.402 20.402 7 32 7ZM32 46.0802C41.9854 46.0802 50.0802 37.9854 50.0802 28C50.0802 18.0146 41.9854 9.91976 32 9.91976C22.0146 9.91976 13.9198 18.0146 13.9198 28C13.9198 37.9854 22.0146 46.0802 32 46.0802Z",
    fill: "#27AE60"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_204_248)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 28,
    r: 16,
    fill: "#27AE60"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9394 31.6978L25.6258 28.3865C25.2534 28.0143 24.6517 28.0143 24.2793 28.3865C23.9069 28.7586 23.9069 29.3598 24.2793 29.732L28.271 33.7209C28.6434 34.093 29.245 34.093 29.6174 33.7209L39.7207 23.6247C40.0931 23.2525 40.0931 22.6513 39.7207 22.2791C39.3483 21.907 38.7466 21.907 38.3742 22.2791L28.9394 31.6978Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_204_248)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 87,
    r: 16,
    fill: "#51668A"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4913 82.0128C39.4524 81.8447 39.3295 81.7086 39.1663 81.6527L37.8014 81.1977L37.3463 79.8327C37.3102 79.7192 37.2347 79.6224 37.1335 79.5596C37.0324 79.4968 36.9121 79.4721 36.7943 79.4901C36.6766 79.5082 36.5691 79.5676 36.4913 79.6577L34.6363 81.5128C34.5729 81.5774 34.5283 81.6581 34.5072 81.7461C34.486 81.8342 34.4892 81.9264 34.5163 82.0128L34.9514 83.3178L34.3613 83.9377C34.6159 84.1524 34.8517 84.3882 35.0664 84.6428L35.6613 84.0528L36.9914 84.5128C37.0433 84.5287 37.097 84.5372 37.1514 84.5378C37.2825 84.5372 37.4082 84.4851 37.5014 84.3928L39.3464 82.5128C39.4141 82.4508 39.4635 82.3714 39.489 82.2831C39.5147 82.1949 39.5155 82.1014 39.4914 82.0128L39.4913 82.0128Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4918 88.514C33.4924 89.4173 33.0862 90.2728 32.3859 90.843C31.6854 91.4132 30.7653 91.6375 29.8809 91.4537C28.9967 91.2697 28.2423 90.6972 27.8273 89.895C27.4122 89.0928 27.3807 88.1463 27.7414 87.3183C28.1021 86.4903 28.8168 85.8687 29.6869 85.6264C30.5569 85.3841 31.49 85.5466 32.2268 86.069L34.3619 83.939H34.3617C33.1799 82.9391 31.6573 82.4347 30.1123 82.5312C28.5672 82.6276 27.1192 83.3177 26.0709 84.4569C25.0227 85.5962 24.4554 87.0965 24.4876 88.6443C24.5198 90.1921 25.149 91.6674 26.2437 92.762C27.3383 93.8566 28.8137 94.4859 30.3614 94.518C31.9091 94.5503 33.4094 93.983 34.5488 92.9348C35.688 91.8866 36.378 90.4386 36.4745 88.8934C36.571 87.3483 36.0665 85.8256 35.0667 84.6439L32.9366 86.779V86.7789C33.297 87.2858 33.491 87.892 33.4917 88.5139L33.4918 88.514Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8466 88.8666C30.7527 88.9613 30.625 89.0145 30.4916 89.0145C30.3582 89.0145 30.2304 88.9613 30.1365 88.8666C30.0419 88.7728 29.9887 88.645 29.9887 88.5116C29.9887 88.3782 30.0419 88.2504 30.1365 88.1566L31.4916 86.7966C30.9206 86.4597 30.2209 86.4236 29.6184 86.7C29.0157 86.9763 28.5866 87.5302 28.4694 88.1827C28.3523 88.8353 28.5619 89.5038 29.0307 89.9725C29.4994 90.4413 30.1679 90.6509 30.8205 90.5338C31.473 90.4166 32.0269 89.9875 32.3032 89.3848C32.5796 88.7823 32.5435 88.0826 32.2066 87.5116L30.8466 88.8666Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_204_248)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 199,
    r: 16,
    fill: "#0B2653"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.2926 193.844C36.2821 193.705 34.3459 192.873 32.9309 191.555L32.5584 191.208C32.4096 191.069 32.2234 191 32 191C31.7767 191 31.5904 191.069 31.4416 191.208L31.0692 191.555C29.6171 192.907 27.7183 193.705 25.7075 193.844C25.2979 193.878 25 194.191 25 194.572V196.653C25 201.022 27.5317 205.079 31.6276 207.229C31.7392 207.299 31.8883 207.333 32 207.333C32.1488 207.333 32.2608 207.299 32.3724 207.229C36.4683 205.079 39 201.022 39 196.653V194.572C39 194.191 38.7021 193.879 38.2925 193.844H38.2926ZM31.9629 194.711C32.5959 194.711 33.1171 195.196 33.08 195.82L32.8566 199.878C32.8195 200.329 32.4471 200.675 31.963 200.675C31.4789 200.675 31.1067 200.328 31.0693 199.878L30.8459 195.82C30.8459 195.196 31.33 194.711 31.963 194.711H31.9629ZM31.9629 203.657C31.2929 203.657 30.7713 203.172 30.7713 202.548C30.7713 201.923 31.2926 201.438 31.9629 201.438C32.633 201.438 33.1545 201.923 33.1545 202.548C33.1543 203.172 32.633 203.657 31.9629 203.657Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_204_248)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 143,
    r: 16,
    fill: "#D17837"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.9672 141.064H23.9777C23.6912 141.064 23.457 141.299 23.457 141.585V147.539C23.457 147.826 23.6912 148.06 23.9777 148.06H26.9672C27.2538 148.06 27.4879 147.826 27.4879 147.539V141.588C27.4879 141.299 27.2566 141.065 26.9672 141.065V141.064ZM26.0442 147.327C25.7301 147.327 25.4739 147.071 25.4739 146.757C25.4739 146.443 25.7301 146.187 26.0442 146.187C26.3582 146.187 26.6144 146.443 26.6144 146.757C26.6146 147.071 26.3583 147.327 26.0442 147.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5286 143.914C40.3494 143.801 40.1263 143.787 39.9362 143.881L36.5886 145.426C36.3737 145.71 36.0348 145.892 35.6518 145.892H32.7478C32.5962 145.892 32.4723 145.768 32.4723 145.616C32.4723 145.465 32.5962 145.341 32.7478 145.341H35.6518C35.8749 145.341 36.0733 145.222 36.1835 145.046C36.2111 145.005 36.2303 144.958 36.247 144.911C36.2524 144.897 36.2552 144.886 36.258 144.873C36.2718 144.82 36.2801 144.768 36.2801 144.713C36.2801 144.366 35.9963 144.082 35.6491 144.082H33.5744C33.5055 144.082 33.4394 144.057 33.3899 144.01C32.4778 143.186 31.3316 142.679 30.3288 142.655C29.403 142.633 28.5599 142.638 28.0392 142.644L28.0391 146.749C29.3754 147.518 32.004 148.895 33.0538 148.832C35.2773 148.705 40.4242 145.016 40.4738 144.978C40.4821 144.972 40.4903 144.967 40.4986 144.961C40.6914 144.854 40.8099 144.65 40.8099 144.429C40.8154 144.22 40.7107 144.03 40.5289 143.914L40.5286 143.914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6 136.568C37.6 137.158 36.3465 137.636 34.8 137.636C33.2536 137.636 32 137.158 32 136.568C32 135.978 33.2536 135.5 34.8 135.5C36.3464 135.5 37.6 135.978 37.6 136.568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8001 142.46C36.4027 142.46 37.6001 141.896 37.6001 141.392L37.6 140.671C37.0163 141.102 36.0019 141.376 34.8 141.376C33.5981 141.376 32.5837 141.102 32 140.671V141.392C32.0001 141.896 33.1975 142.46 34.8002 142.46H34.8001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8001 140.852C36.4027 140.852 37.6001 140.288 37.6001 139.783L37.6 139.062C37.0163 139.493 36.0019 139.767 34.8 139.767C33.5981 139.767 32.5837 139.493 32 139.062V139.783C32.0001 140.288 33.1975 140.852 34.8002 140.852H34.8001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8001 139.244C36.4027 139.244 37.6001 138.68 37.6001 138.176L37.6 137.455C37.0163 137.886 36.0019 138.16 34.8 138.16C33.5981 138.16 32.5837 137.886 32 137.455V138.176C32.0001 138.68 33.1975 139.244 34.8002 139.244H34.8001Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_204_248)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 255,
    r: 16,
    fill: "#4081BD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.5559 252.937C38.1502 251.606 37.3455 250.466 36.2268 249.633L32.5996 254.755L38.4679 256.98C38.9316 255.664 38.9621 254.268 38.556 252.937L38.5559 252.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4826 255.112L31.4653 255.097C31.4486 255.078 31.4366 255.057 31.4295 255.034C31.4146 254.986 31.4232 254.932 31.4531 254.889L35.2042 249.592C35.0212 249.47 34.8306 249.355 34.6354 249.251C33.6929 248.75 32.6391 248.484 31.5877 248.484C30.9487 248.484 30.3109 248.58 29.6921 248.769C28.0314 249.276 26.6676 250.399 25.8516 251.931C25.0357 253.464 24.8654 255.222 25.3719 256.883C25.8786 258.544 27.0017 259.907 28.5342 260.724C29.475 261.225 30.5281 261.489 31.5804 261.489C32.2224 261.489 32.8638 261.393 33.4861 261.203C35.3611 260.631 36.8561 259.264 37.5998 257.444L31.511 255.133C31.4973 255.126 31.488 255.118 31.4824 255.113L31.4826 255.112Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_204_248)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 311,
    r: 16,
    fill: "#A85CD7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.0001 306.162H35.8001V304.296C35.8001 303.929 35.5001 303.629 35.1335 303.629H28.6001C28.2334 303.629 27.9334 303.929 27.9334 304.296V306.162H25C24.4334 306.162 24 306.629 24 307.162V309.729H40V307.162C40 306.629 39.5666 306.162 39 306.162H39.0001ZM29.2667 304.962H34.4667V306.162H29.2667V304.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8 312.059H36.1V310.859H27.9V312.059H26.2V310.859H24V317.359C24 317.893 24.4334 318.359 25 318.359H39C39.5667 318.359 40 317.893 40 317.359V310.859H37.8V312.059Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_204_248",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_204_248",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_204_248",
    x: 0,
    y: 59,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_204_248",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_204_248",
    x: 0,
    y: 171,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_204_248",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_204_248",
    x: 0,
    y: 115,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_204_248",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_204_248",
    x: 0,
    y: 227,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_204_248",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_204_248",
    x: 0,
    y: 283,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_204_248",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(22 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step_2.64a9a5e240ef83ce779932267b548285.svg";
export { ForwardRef as ReactComponent };